import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './theme.css';
import './recentHighlight.css';
import './bugCard.css';
import App from './App';
import { ThemeProvider } from './context/ThemeContext';
import { LangProvider, normalizeLanguage, resolveLanguage } from './LanguageContext';
import { installFetchRateLimitRedirect } from './utils/installFetchRateLimitRedirect';
import { initRateLimitBroadcast } from './utils/rateLimitBackoff';

const detectInitialLanguage = () => {
  if (typeof window === 'undefined') {
    return 'en';
  }

  const fallback = 'en';

  try {
    const stored = window.localStorage.getItem('lang');
    const storedNormalized = normalizeLanguage(stored);
    if (storedNormalized) {
      return storedNormalized;
    }
  } catch (err) {
    // Ignore read failures (e.g. private mode)
  }

  const navigatorLanguages = [];
  const nav = window.navigator;
  if (nav) {
    if (Array.isArray(nav.languages)) {
      navigatorLanguages.push(...nav.languages);
    }
    if (nav.language) navigatorLanguages.push(nav.language);
    if (nav.userLanguage) navigatorLanguages.push(nav.userLanguage);
    if (nav.browserLanguage) navigatorLanguages.push(nav.browserLanguage);
  }

  for (const candidate of navigatorLanguages) {
    const normalized = normalizeLanguage(candidate);
    if (normalized) {
      return normalized;
    }
  }

  return fallback;
};

const initialLang = detectInitialLanguage();

initRateLimitBroadcast();
installFetchRateLimitRedirect();

if (typeof window !== 'undefined') {
  try {
    window.localStorage.setItem('lang', resolveLanguage(initialLang));
  } catch (err) {
    // Ignore write failures
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LangProvider initialLang={initialLang}>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </LangProvider>
  </React.StrictMode>
);
